var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      ref: "article",
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c("div", { staticClass: "thumb-image" }, [
            _c(
              "div",
              { staticClass: "prop-1-1" },
              [
                _vm._t("item-image", function() {
                  return [
                    _c("category-image-carousel", {
                      ref: "categoryImageCarousel",
                      attrs: {
                        "image-urls-data": _vm._f("itemImages")(
                          _vm.item.images,
                          _vm.imageUrlAccessor
                        ),
                        alt: _vm._f("itemName")(_vm.item),
                        title: _vm._f("itemName")(_vm.item),
                        "item-url": _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                        "enable-carousel": false,
                        "disable-carousel-on-mobile": true
                      }
                    })
                  ]
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm._t("store-special", function() {
            return [
              _vm.storeSpecial ||
              _vm.item.variation.bundleType === "bundle" ||
              _vm.item.item.itemType === "set"
                ? _c("item-store-special", {
                    attrs: {
                      "store-special": _vm.storeSpecial,
                      "recommended-retail-price": _vm.item.prices.rrp,
                      "variation-retail-price": _vm.item.prices.default,
                      "special-offer-price": _vm.item.prices.specialOffer,
                      "decimal-count": _vm.decimalCount,
                      "bundle-type": _vm.item.variation.bundleType,
                      "item-type": _vm.item.item.itemType
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _vm._t("item-details", function() {
            return [
              _c(
                "div",
                { staticClass: "thumb-content" },
                [
                  _c("div", { staticClass: "category-item__color-wrapper" }, [
                    _vm.item.item.salableVariationCount > 1
                      ? _c("div", { staticClass: "category-item__colors" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("ODStylebreaker::Template.color")
                            ) + "\n                            "
                          ),
                          _vm._m(0)
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("hr", { staticClass: "thumb-content__hr" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "thumb-content__txt" }, [
                    _c(
                      "a",
                      {
                        staticClass: "thumb-title small",
                        attrs: {
                          href: _vm._f("itemURL")(
                            _vm.item,
                            _vm.urlWithVariationId
                          )
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.item.texts.name2)
                        ),
                        _vm._l(_vm.item.groupedAttributes, function(attribute) {
                          return _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")(
                                  "Ceres::Template.itemGroupedAttribute",
                                  attribute
                                )
                              )
                            )
                          ])
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "thumb-meta mt-2" },
                      [
                        _vm._t("before-prices"),
                        _vm._v(" "),
                        _c("div", { staticClass: "prices" }, [
                          _vm.item.prices.rrp &&
                          _vm.item.prices.rrp.price.value > 0 &&
                          _vm.item.prices.rrp.price.value >
                            _vm.item.prices.default.unitPrice.value
                            ? _c("div", { staticClass: "price-view-port" }, [
                                _vm.item.prices.specialOffer
                                  ? _c("del", { staticClass: "crossprice" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.item.prices.default.unitPrice
                                              .formatted
                                          ) +
                                          "\n                                    "
                                      )
                                    ])
                                  : _c("del", { staticClass: "crossprice" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.item.prices.rrp.unitPrice
                                              .formatted
                                          ) +
                                          "\n                                    "
                                      )
                                    ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "price" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm._f("specialOffer")(
                                    _vm.item.prices.default.unitPrice.formatted,
                                    _vm.item.prices,
                                    "unitPrice",
                                    "formatted"
                                  )
                                ) +
                                "\n                                "
                            )
                          ])
                        ])
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _vm._t("after-prices"),
                  _vm._v(" "),
                  !(
                    _vm.item.unit.unitOfMeasurement === "C62" &&
                    _vm.item.unit.content === 1
                  )
                    ? _c("div", { staticClass: "category-unit-price small" }, [
                        _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.item.unit.names.name))
                        ]),
                        _vm._v(" "),
                        _vm.item.variation.mayShowUnitPrice
                          ? _c("span", [
                              _vm._v(
                                " | " +
                                  _vm._s(_vm.item.prices.default.basePrice)
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "vat small text-muted" }, [
                    _vm._v("\n                    * "),
                    _vm.showNetPrices
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Ceres::Template.itemExclVAT")
                            )
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Ceres::Template.itemInclVAT")
                            )
                          )
                        ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate("Ceres::Template.itemExclusive")
                        ) +
                        "\n                    "
                    ),
                    _vm.$ceres.config.global.hasShippingCostsCategoryId > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "text-appearance",
                            attrs: {
                              "data-toggle": "modal",
                              href: "#shippingscosts",
                              title: _vm.$translate(
                                "Ceres::Template.itemShippingCosts"
                              )
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.itemShippingCosts"
                                )
                              )
                            )
                          ]
                        )
                      : _c(
                          "a",
                          {
                            attrs: {
                              title: _vm.$translate(
                                "Ceres::Template.itemShippingCosts"
                              )
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.itemShippingCosts"
                                )
                              )
                            )
                          ]
                        )
                  ])
                ],
                2
              )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "category-item__hover category-item__hover--wishlist" },
        [
          _c("add-to-wish-list", {
            attrs: { "variation-id": _vm.item.variation.id }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "category-item__hover category-item__hover--quickview",
          class: { "cursor-not-allowed": _vm.isLoadingVariations }
        },
        [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.loadVariationImages()
                }
              }
            },
            [
              !_vm.isLoadingVariations
                ? _c("i", { staticClass: "icon-view" })
                : _c("i", { staticClass: "fa fa-spinner" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$translate("ODStylebreaker::Template.quickView"))
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showItemModal,
              expression: "showItemModal"
            }
          ],
          ref: "quickViewModal",
          staticClass: "category-item__quick-view-item-modal"
        },
        [
          _c(
            "button",
            {
              staticClass: "search-autocomplete__close btn-close",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.closeItemQuickView()
                }
              }
            },
            [_vm._v("\n                ×\n            ")]
          ),
          _vm._v(" "),
          _vm.showItemModal
            ? _c(
                "div",
                { staticClass: "category-item__quick-view-item-image" },
                [
                  _c("item-image-carousel", {
                    attrs: {
                      "max-quantity": 8,
                      "image-url-accessor": "urlMiddle",
                      "show-thumbs": true,
                      "show-dots": false,
                      "animation-style": "",
                      "enable-lightbox": false,
                      "plugin-path": _vm.pluginPath,
                      "category-item-data": _vm.item
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showItemModal
            ? _c("div", { staticClass: "category-item__quick-view-info" }, [
                _c(
                  "div",
                  { staticClass: "category-item__quick-view-headline" },
                  [_vm._v(_vm._s(_vm.item.texts.name2))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "category-item__quick-view-price-wrapper" },
                  [
                    _c(
                      "span",
                      { staticClass: "category-item__quick-view-price" },
                      [
                        _c("div", { staticClass: "prices" }, [
                          _c(
                            "div",
                            {
                              staticClass: "price",
                              class: {
                                "crossprice-color":
                                  _vm.item.prices.rrp &&
                                  _vm.item.prices.rrp.price.value > 0 &&
                                  _vm.item.prices.rrp.price.value >
                                    _vm.item.prices.default.unitPrice.value
                              }
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm._f("specialOffer")(
                                      _vm.item.prices.default.unitPrice
                                        .formatted,
                                      _vm.item.prices,
                                      "unitPrice",
                                      "formatted"
                                    )
                                  ) +
                                  "\n                                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.item.prices.rrp &&
                          _vm.item.prices.rrp.price.value > 0 &&
                          _vm.item.prices.rrp.price.value >
                            _vm.item.prices.default.unitPrice.value
                            ? _c(
                                "div",
                                { staticClass: "price-view-port ml-1" },
                                [
                                  _vm.item.prices.specialOffer
                                    ? _c("del", { staticClass: "crossprice" }, [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.item.prices.default.unitPrice
                                                .formatted
                                            ) +
                                            "\n                                    "
                                        )
                                      ])
                                    : _c("del", { staticClass: "crossprice" }, [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.item.prices.rrp.unitPrice
                                                .formatted
                                            ) +
                                            "\n                                    "
                                        )
                                      ])
                                ]
                              )
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(1)
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "category-item__quick-view-txt" }, [
                  _vm._v(
                    "Artikelnummer:    " + _vm._s(_vm.item.variation.number)
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "category-item__quick-view-details" },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm._f("itemURL")(
                            _vm.item,
                            _vm.urlWithVariationId
                          ),
                          title: _vm.item.texts.name2
                        }
                      },
                      [_vm._v("Artikeldetails")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm.attributesMap.length
                  ? _c(
                      "div",
                      [
                        _c("variation-select-category", {
                          attrs: {
                            attributes: _vm.attributesMap,
                            variations: _vm.variationsMap,
                            "item-variations": _vm.variations,
                            "variation-id": _vm.item.variation.id,
                            "selected-variation": _vm.item
                          },
                          on: { childToParent: _vm.onChildClick }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showItemModal
            ? _c(
                "div",
                { staticClass: "category-item__quick-view-basket-row" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "category-item__quick-view-basket-col--left"
                    },
                    [
                      _vm.attributesMap
                        ? _c("variation-select-category", {
                            attrs: {
                              attributes: _vm.attributesMap,
                              variations: _vm.variationsMap,
                              "item-variations": _vm.variations,
                              "variation-id": _vm.item.variation.id,
                              "selected-variation": _vm.item,
                              "is-size": true
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "category-item__quick-view-basket-col--right"
                    },
                    [
                      _c("QuantityInput", {
                        attrs: { value: _vm.qty },
                        on: { "quantity-change": _vm.updateQty }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "category-item__quick-view-basket-col--left od-wishlist"
                    },
                    [
                      _c("add-to-wish-list", {
                        attrs: { "variation-id": _vm.item.variation.id }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "category-item__quick-view-basket-col--right"
                    },
                    [
                      _vm.item
                        ? _c("add-to-basket", {
                            attrs: {
                              "variation-id": _vm.item.variation.id,
                              "item-id-category": _vm.item.item.id,
                              "is-salable":
                                !!_vm.item.filter && _vm.item.filter.isSalable,
                              "has-children":
                                !!_vm.item.filter &&
                                _vm.item.filter.hasActiveChildren,
                              "interval-quantity":
                                _vm.item.variation.intervalOrderQuantity || 1,
                              "minimum-quantity":
                                _vm.item.variation.minimumOrderQuantity,
                              "maximum-quantity":
                                !!_vm.item.variation.maximumOrderQuantity &&
                                _vm.item.variation.maximumOrderQuantity > 0
                                  ? _vm.item.variation.maximumOrderQuantity
                                  : null,
                              "order-properties": _vm.item.properties.filter(
                                function(prop) {
                                  return prop.property.isOderProperty
                                }
                              ),
                              "has-order-properties":
                                _vm.item.hasOrderProperties,
                              "use-large-scale": false,
                              "show-quantity": false,
                              "item-url": _vm._f("itemURL")(_vm.item),
                              "has-price": _vm._f("hasItemDefaultPrice")(
                                _vm.item
                              ),
                              propQuantity: _vm.qty
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "category-item__color-icon" }, [
      _c("div", { staticClass: "category-item__part category-item__part--1" }),
      _vm._v(" "),
      _c("div", { staticClass: "category-item__part category-item__part--2" }),
      _vm._v(" "),
      _c("div", { staticClass: "category-item__part category-item__part--3" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass:
          "category-item__quick-view-txt category-item__quick-view-txt--after-price"
      },
      [
        _vm._v("    inkl. MwSt., zzgl. "),
        _c("a", { attrs: { href: "/zahlung-und-versand", title: "Versand" } }, [
          _vm._v("Versand")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }